import React from "react";
import Form from "../Components/Form";
import "semantic-ui-css/semantic.min.css";
import Inst from "../assets/instagram_logo.png";
import Facebook from "../assets/facebook_logo.png";
import Google from "../assets/google_logo.png";
import { Helmet } from "react-helmet-async";
import { Translation } from "react-i18next";

export default class Contact extends React.Component {
  render() {
    return (
      <>
        <Translation>
          {(t) => (
            <Helmet>
              <title>
                {t(["seo_contact.title"])}
                {/*  AN_DESIGN | Дизайн інтер'єру Україна та Європа, 3D-візуалізація */}
              </title>
              <meta
                name="description"
                content={t([
                  "seo_contact.description",
                ])} /* "Професійні послуги з дизайну інтер’єру в Україні та Європі. Повний пакет / Пакет лайт / Пакет креслення пакети пакети з 3D-візуалізацією, плануванням меблів та підбором матеріалів." */
              />
              <meta
                name="keywords"
                content={t([
                  "seo_contact.keywords",
                ])} /* "дизайн інтер'єру, дизайн інтер'єру Київ, дизайн інтер'єру Україна, дизайн інтер'єру Європа, проект інтер'єру, 3D візуалізація, ремонт квартир, дизайн проект будинку, інтер'єр квартири, AN_DESIGN" */
              />
              <link
                rel="canonical"
                href="https://an-design-7e5aa.web.app/contact"
              />
              {/* Open Graph for social sharing */}
              <meta property="og:title" content={t(["seo_contact.title"])} />
              <meta
                property="og:description"
                content={t(["seo_contact.description"])}
              />
              <meta property="og:type" content="website" />
              <meta
                property="og:url"
                content="https://an-design-7e5aa.web.app/contact"
              />
              <meta
                property="og:image"
                content="https://an-design-7e5aa.web.app/og-image.png"
              />
            </Helmet>
          )}
        </Translation>
        <div>
          <Form />
          <footer className="py-3 footer-fixed footer-inner">
            <div className="row">
              <div
                className="col d-flex align-items-center text-muted"
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  color: "#1c4280",
                }}
              >
                2023 AN_DESIGN
              </div>
              <div className="col d-flex align-items-center justify-content-end">
                <a
                  href="https://www.instagram.com/_an.design_"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={Inst}
                    alt="logo instagram"
                    className="img-fluid"
                    width={30}
                    style={{
                      marginRight: "1em",
                    }}
                  />
                </a>
                <a
                  href="https://www.facebook.com/an.design2018/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={Facebook}
                    alt="logo facebook"
                    className="img-fluid"
                    width={30}
                    style={{
                      marginRight: "1em",
                    }}
                  />
                </a>
                <a href="mailto:korolskaya.anya@gmail.com">
                  <img
                    src={Google}
                    alt="logo google"
                    className="img-fluid"
                    width={30}
                  />
                </a>
              </div>
            </div>
          </footer>
        </div>
      </>
    );
  }
}
